import type { ReactElement } from 'react'

import type { SeriesPageWorld } from '@/common/services/seriesPage/types'

import { SeriesTodoList, type WorldDetailsForTodoList } from '@/components/Worlds/Todos/TodoList'

export default function SeriesHomeTasks({
  world,
  isUserHost,
}: {
  world: SeriesPageWorld | null
  isUserHost: boolean
}): ReactElement {
  const worldDetailsForTodoList: WorldDetailsForTodoList = {
    slug: world?.slug ?? '',
    iconUrl: world?.iconUrl ?? '',
    title: world?.title ?? '',
    primaryColor: world?.primaryColor ?? '',
  }

  return (
    <SeriesTodoList
      world={worldDetailsForTodoList}
      headingSize="xl"
      maxToShow={2}
      includeWorldInfo
      excludeTargetLevel={isUserHost ? 'member' : 'tutor'}
    />
  )
}
